import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, CartProvider } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartSheet from "./components/CartSheet";
import VerifyBanner from "./components/VerifyBanner";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import MyOrders from "./pages/MyOrders";
import Admin from "./pages/Admin";
import PrintOrder from "./pages/PrintOrder";
import TrackOrder from "./pages/TrackOrder";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Layout() {
  const [cartOpen, setCartOpen] = useState(false);
  const location = useLocation();
  const isPrintPage = location.pathname.startsWith("/admin/print");

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      {!isPrintPage && <Header onOpenCart={() => setCartOpen(true)} />}
      {!isPrintPage && <VerifyBanner />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/track/:orderId" element={<TrackOrder />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/print/:id" element={<PrintOrder />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isPrintPage && <Footer />}
      <CartSheet open={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Layout />
          <Toaster richColors position="top-right" />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
